export default "__VITE_ASSET__BI6KPfnh__"